// Module
var code = `<div class="page-content request-access">

    <section class="early-access">

        <p class="early-access__eyebrow">
            Early access · Structural API &amp; Agent Skills
        </p>

        <h1 class="early-access__headline">
            Request early access.
        </h1>

        <p class="early-access__subhead">
            <b>SpyneJS Agent Skills</b> and the <b>Structural API</b> are shipping in the next few weeks. Early access is offered first to developers planning to build with SpyneJS and willing to share feedback as we finalize the public release.
        </p>

        <p class="early-access__body">
            Members of the early access cohort will receive setup instructions before general availability, get direct contact with the team during their first build, and help shape what ships publicly. If that fits what you're looking for, the form below is the way in.
        </p>

        <form data-event-prevent-default="true" class="early-access-form" id="early-access-form" novalidate>

            <div class="early-access-form__field">
                <label for="ea-email" class="early-access-form__label">
                    Email
                </label>
                <input
                        type="email"
                        id="ea-email"
                        name="email"
                        class="early-access-form__input"
                        autocomplete="email"
                        required
                />
                <p class="early-access-form__error" id="ea-email-error" aria-live="polite"></p>
            </div>

            <div class="early-access-form__field">
                <div class="early-access-form__label-row">
                    <label for="ea-context" class="early-access-form__label">
                        What are you planning to build with SpyneJS?
                    </label>
                    <span class="early-access-form__optional">Optional</span>
                </div>
                <textarea
                        id="ea-context"
                        name="context"
                        rows="4"
                        class="early-access-form__textarea"
                        placeholder="A dashboard, a CMS, an internal tool, an agentic workflow&hellip;"
                ></textarea>
            </div>

            <!-- Honeypot: hidden from users, catches bots -->
            <div class="early-access-form__honeypot" aria-hidden="true">
                <label for="ea-website">Website</label>
                <input
                        type="text"
                        id="ea-website"
                        name="_website_url"
                        tabindex="-1"
                        autocomplete="off"
                />
            </div>

            <button type="submit" class="early-access-form__submit" id="ea-submit">
                <span class="early-access-form__submit-label">Request Access</span>
            </button>

            <p class="early-access-form__footnote">
                We'll email you within a few weeks when access opens. The form sends directly to Frank.
            </p>

        </form>

        <!-- Success state, replaces the form on submit -->
        <div class="early-access-success" id="early-access-success" hidden>
            <h2 class="early-access-success__title">You're on the list.</h2>
            <p class="early-access-success__body">
                Thanks for requesting access. A confirmation is on its way to your inbox &mdash; if it doesn't arrive in a minute or two, check your spam folder.
            </p>
            <p class="early-access-success__body">
                We'll be in touch within a few weeks when access opens. In the meantime:
            </p>
            <ul class="early-access-success__links">
                <li>
                    <a href="https://github.com/spynejs" target="_blank" class="early-access-success__link">
                        Browse the GitHub repos <span class="early-access-success__arrow">&rarr;</span>
                    </a>
                </li>
                <li>
                    <a data-channel="ROUTE" data-event-prevent-default="true" data-page-id="docs" data-end-route="true" href="/docs" class="early-access-success__link">
                        Read the framework docs <span class="early-access-success__arrow">&rarr;</span>
                    </a>
                </li>
            </ul>
        </div>

    </section>

</div>
`;
// Exports
module.exports = code;